export default function clearPx(value: string): number {
  return +value.substring(0, value.length - 2);
}
